import { EDGE_RIGHTSHOLDER_ATTRIBUTION } from '../constants/config';
import { readEdgeAttributionMode } from './updateUserPreferences';

/**
 * Determines if useRightsholderAttribution should be sent to API
 * Reads from localStorage directly (like useRightsholderAttribution hook does),
 * through the same readEdgeAttributionMode helper the hook uses so this flag can
 * never disagree with the position the switch is showing.
 * @param {Object} client - The client object with permissions
 * @param {number} clientId - The client ID
 * @returns {boolean} - Whether to use rightsholder attribution
 */
const getUseRightsholderAttribution = (client, clientId) => {
    if (!client || !clientId) return false;

    const hasRhAttributionPermission = client?.permissions?.includes(
        EDGE_RIGHTSHOLDER_ATTRIBUTION,
    );

    if (!hasRhAttributionPermission) return false;

    // A corrupt mvc-user must not break every query on the page.
    let storedUser = null;
    try {
        storedUser = JSON.parse(localStorage.getItem('mvc-user') || 'null');
    } catch {
        return false;
    }

    return (
        readEdgeAttributionMode(
            storedUser?.userPreferences?.rightsholder_attribution,
            clientId,
        ) === 'league'
    );
};

export default getUseRightsholderAttribution;
